import { Component, Input } from '@angular/core';

/**
 * Generated class for the HeroComponent component.
 *
 * See https://angular.io/docs/ts/latest/api/core/index/ComponentMetadata-class.html
 * for more info on Angular Components.
 */
@Component({
  selector: 'hero',
  templateUrl: 'hero.html'
})
export class HeroComponent {
  @Input() platform: any = {};
  @Input() title: string = 'Dashboard';
  @Input() subTitle: string = 'Platform overview';
  constructor() {
  }

}



// WEBPACK FOOTER //
// ./src/components/hero/hero.ts